/**
 * Builds the download filename (without extension) of a generated template
 * document. Prefers the dedicated `<USE_CASE>_FILENAME` i18n key, which
 * interpolates a reference, and falls back to the plain use case label when
 * either the reference or that key is missing.
 * @function
 *
 * @param {Object} params - The parameters object.
 * @param {Function} params.t - The i18next translation function.
 * @param {string} params.useCase - The template document use case (e.g. PENSIONER_CONTRACT).
 * @param {string|number} [params.reference] - The reference to include in the filename.
 * @param {Object} [params.values] - Named interpolations for filenames built on
 * something other than a reference, such as the practice name of an advert.
 * @returns {string} The filename, without extension.
 */
export const templateDocumentFileName = ({ t, useCase, reference, values }) => {
  const label = t(`template-documents.form.${useCase}`, {
    defaultValue: useCase || 'document'
  });

  const namedValues = values || {};
  const hasNamedValue = Object.values(namedValues).some(
    (value) => value !== undefined && value !== null && `${value}`.trim() !== ''
  );

  if (!useCase || (!reference && !hasNamedValue)) return label;

  return t(`template-documents.form.${useCase}_FILENAME`, {
    reference,
    ...namedValues,
    defaultValue: label
  });
};
